/**
 * Remembers that the install banner was waved away, for a fortnight.
 *
 * A timestamp and nothing else — no user data — so localStorage is fine.
 * Wrapped because Safari private mode and "block site data" make the accessor
 * itself throw (the same guard as the sidebar preference).
 */
export const INSTALL_DISMISS_KEY = 'pwa:install-dismissed-at';
export const INSTALL_DISMISS_TTL_MS = 14 * 24 * 60 * 60 * 1000;

export function readInstallDismissedAt(): number | null {
  try {
    const raw = localStorage.getItem(INSTALL_DISMISS_KEY);
    if (raw === null) return null;
    const at = Number(raw);
    return Number.isFinite(at) ? at : null;
  } catch {
    return null;
  }
}

export function writeInstallDismissed(now: number): void {
  try {
    localStorage.setItem(INSTALL_DISMISS_KEY, String(now));
  } catch {
    /* storage unavailable — the banner simply returns next visit */
  }
}

export function isInstallDismissed(now: number): boolean {
  const at = readInstallDismissedAt();
  return at !== null && now - at < INSTALL_DISMISS_TTL_MS;
}
